var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invocation-period-selection"},_vm._l((_vm.periodOptions),function(option,key){return _c('button',{key:key,staticClass:"invocation-period-selection__selector",class:{
      'invocation-period-selection__selector--active':
        option === _vm.selectedPeriod,
    },on:{"click":function($event){return _vm.handleSelectPeriod(option)}}},[_vm._v(" "+_vm._s(option)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }